/* unplugin-vue-components disabled */import { render } from "./authorize.vue?vue&type=template&id=0d9b71b4"
import script from "./authorize.vue?vue&type=script&lang=js"
export * from "./authorize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__